export default __webpack_public_path__ + "static/color-picker-agnostic-color-dont-c390d3bc7d6545d944baafe385828df2.png";